module.exports = __webpack_public_path__ + "img/0Q3A4704_L_Black.f68e7ef8.jpg";